<section slimScroll class="pr-2 sen-psd-pud">
    <section class="mt-2" fxLayout="row" fxLayoutAlign="space-between top">
        <section fxLayout="column" fxFlex="1 1 48%">
            <p class="sen-fs12">{{translate.getLng('RU_DATA')}}</p>
            <h4>{{translate.getLng('CURRENT_INPUT')}}</h4>
            <mat-form-field class="example-full-width">
                <mat-label>{{translate.getLng('NAME')}}</mat-label>
                <input matInput>
            </mat-form-field>
            <sen-app-input-address></sen-app-input-address>
            <button mat-raised-button color="primary" class="float-right ml-auto mb-2">{{translate.getLng('ADD')}}
                <mat-icon>
                    arrow_right_alt</mat-icon>
            </button>
        </section>
        <section fxLayout="column" fxFlex="1 1 48%">
            <div class="sen-info-color-bg p-3 mb-2" fxFlex="1 1 auto">
                <label>{{translate.getLng('CUSTOM_UTILITY')}}</label>
                <table mat-table class="w-100" [dataSource]="dataSource">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('NAME')}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tbd">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> {{element.tbd}} </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td class="text-right" mat-cell *matCellDef="let element">
                            <mat-icon class="sen-active-color pt-2 sen-cursor-pointer sen-fs16">delete
                            </mat-icon>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </section>
    </section>
    <mat-divider class="my-3"></mat-divider>
    <section class="mt-2" fxLayout="row" fxLayoutAlign="space-between top">
        <section fxLayout="column" fxFlex="1 1 48%">
            <h4>{{translate.getLng('SEARCH_EVU_ARCHIVE')}}</h4>
            <p class="sen-fs12">{{translate.getLng('AT_THE_MOMENT')}}</p>
            <mat-form-field class="example-full-width">
                <mat-label>{{translate.getLng('NAME')}}</mat-label>
                <input matInput>
            </mat-form-field>
            <sen-app-input-address></sen-app-input-address>
            <button mat-raised-button color="primary" class="float-right ml-auto mb-2">
                {{translate.getLng('SEARCH')}} <mat-icon>arrow_right_alt</mat-icon>
            </button>
        </section>
        <section fxLayout="column" fxFlex="1 1 48%">
            <div class="sen-info-color-bg p-3 mb-2" fxFlex="1 1 auto">
                <table mat-table class="w-100" [dataSource]="dataSourceEVU">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('NAME')}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="zip">
                        <th mat-header-cell *matHeaderCellDef> {{translate.getLng('ZIP')}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.zip}} </td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                        <th mat-header-cell *matHeaderCellDef>{{translate.getLng('CITY')}} </th>
                        <td mat-cell *matCellDef="let element"> {{element.city}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsEVU"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsEVU;"></tr>
                </table>
            </div>
        </section>
    </section>
</section>